/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ task: NonNullable<unknown>, scope: NonNullable<unknown> }} Task_Catalog_Issue_RequiredInputs */

const en_task_catalog_issue_required = /** @type {(inputs: Task_Catalog_Issue_RequiredInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.task} is required in ${i?.scope}.`)
};

const pt_br2_task_catalog_issue_required = /** @type {(inputs: Task_Catalog_Issue_RequiredInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.task} é obrigatória em ${i?.scope}.`)
};

/**
* | output |
* | --- |
* | "{task} is required in {scope}." |
*
* @param {Task_Catalog_Issue_RequiredInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_catalog_issue_required = /** @type {((inputs: Task_Catalog_Issue_RequiredInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Catalog_Issue_RequiredInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_catalog_issue_required(inputs)
	return pt_br2_task_catalog_issue_required(inputs)
});